var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgGb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  className: "icon icon__engb",
  viewBox: "0 0 18 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FEFEFE",
  d: "M.97 13h16.06c.516-.028.931-.444.931-.947V1.947c0-.519-.438-.944-.977-.947H1.016c-.539.003-.977.428-.977.947V12.05c0 .506.416.921.932.95Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M7.747 8.197V13h2.494V8.197h7.72v-2.4h-7.72V1H7.747v4.797H.039v2.4h7.708Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#012169",
  d: "M11.07 4.884V1h5.92a.989.989 0 0 1 .902.6L11.07 4.884Zm0 4.231V13h5.958a.994.994 0 0 0 .864-.6L11.07 9.116Zm-4.152 0V13H.973a.985.985 0 0 1-.864-.606l6.809-3.278Zm0-4.231V1H1.012a.986.986 0 0 0-.903.606l6.809 3.278ZM.04 5h2.483L.039 3.803V5Zm17.922 0h-2.497l2.497-1.204V5Zm0 4h-2.497l2.497 1.203V9ZM.04 9h2.483L.039 10.196V9Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C8102E",
  d: "M17.962 2.016 11.777 5h1.384l4.801-2.313v-.671ZM6.211 9H4.828L.04 11.306v.671L6.224 9h-.013ZM3.455 5.003h1.383L.039 2.691v.669l3.416 1.643Zm11.077 3.994h-1.384l4.816 2.321v-.668l-3.432-1.653Z"
})));
export default SvgGb;